module.exports = __webpack_public_path__ + "static/media/light.9d0f388d.png";